import React from 'react'
import { Check, Loader2, ChevronRight } from 'lucide-react'
import type { ApprovalPanelProps } from './types'
import styles from '../../pages/DocumentsPage.module.css'

export const ApprovalPanel: React.FC<ApprovalPanelProps> = ({
  stage,
  onApprove,
  onContinue,
  isApproving,
}) => {
  if (stage === 'review') {
    return (
      <div className={styles.approvalSection}>
        <button
          className={styles.approveBtn}
          onClick={onApprove}
          disabled={isApproving}
        >
          {isApproving ? (
            <><Loader2 size={16} className={styles.spinner} /> Approving...</>
          ) : (
            <><Check size={16} /> Approve All Classifications</>
          )}
        </button>
      </div>
    )
  }

  if (stage === 'approved' || stage === 'approved_with_new') {
    return (
      <div className={styles.approvalSection}>
        <div className={styles.approvedInfo}>
          <Check size={16} />
          <span>Classifications approved</span>
        </div>
        <button className={styles.continueBtn} onClick={onContinue}>
          Continue to Income <ChevronRight size={16} />
        </button>
      </div>
    )
  }

  return null
}

